import showHide from './show-hide';
function modal(e) {

	e.preventDefault();
	let id = this.dataset.modal;
	let modal = document.getElementById(id);

	if (modal) {
		showHide(modal);
		if (id == 'video') {
			let media = modal.querySelector('video');	
			media.autoplay = true;
			media.load();
			media.volume = 0.5;
		}
		if (this.dataset.stop) {
			let media = modal.querySelector('video');
			media.autoplay = false;
			media.pause();
			media.currentTime = 0;
		}
	}

}


export default modal;